import { Component, OnInit } from '@angular/core';
import { Client, Workflow } from 'src/app/models';
import { DataService } from 'src/app/services';

@Component({
    selector: 'wm-workflow-error-list',
    templateUrl: './workflow-error-list.component.html',
    styleUrl: './workflow-error-list.component.css',
    standalone: false
})
export class WorkflowErrorListComponent implements OnInit {
  clients: Client[];
  invalidWorkflows: Workflow[];
  clientId: string;

  loading: boolean;

  constructor(private _dataSvc: DataService) { }

  ngOnInit(): void {
    this._dataSvc.getClientsWithWorkflowValidationErrors().subscribe(results => {
      this.clients = results;
    });
  }

  searchWorkflows() {
    if (this.clientId) {
      this.loading = true;
      this._dataSvc.getInvalidWorkflows(this.clientId).subscribe(results => {
        this.invalidWorkflows = results;
        this.loading = false;
      });
    }
  }
}
